const styles = {
  fieldsWrapper: {
    px: 2,
    pb: 10.75,
    minHeight: theme => `calc(100vh - ${theme.spacing(12)})`,
  },
  fields: {
    display: 'grid',
    gridTemplateRows: 'auto',
    gridRowGap: theme => theme.spacing(1.75),
  },
  deleteFiltersButton: { mt: 1.75 },
}

export default styles
